import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Application } from '../../../modules/app-catalog/domain/models/application';
import { AppSearchable } from '../../../modules/app-catalog/domain/models/app-interfaces';
import { TenantContextService } from 'src/app/shared/tenant-context/tenant-context.service';
import { ApplicationHelper } from '../../../modules/app-catalog/domain/services/application-helper';
import { take } from 'rxjs';
import { DatabricksLoginCheckService } from '../../services/databricks-login-check.service';
import { WindowService } from 'src/app/modules/data/data-entry/services/window.service';

@Component({
    selector: 'cdp-app-mini-card',
    templateUrl: './app-mini-card.component.html',
    styleUrls: ['./app-mini-card.component.scss'],
    standalone: false
})
export class AppMiniCardComponent implements OnInit {
    @Input() application: Application;
    @Input() searchText: AppSearchable[];
    @Input() inFavoriteContainer: boolean;
    @Input() isPreviewMode = false;
    @Output() updateLastView = new EventEmitter<Application>();
    @Output() toggleFavorite = new EventEmitter<Application>();
    themeColor = ApplicationHelper.defaultThemeColor;

    constructor(
        private tenantContext: TenantContextService,
        private databricksLoginCheckService: DatabricksLoginCheckService,
        private window: WindowService
    ) {}

    ngOnInit(): void {
        this.tenantContext.tenantSelected$.pipe(take(1)).subscribe(tenant => {
            this.themeColor = tenant?.themeColor || ApplicationHelper.defaultThemeColor;
        });
    }

    async launch(event?: MouseEvent): Promise<void> {
        const url = this.application.url ?? '';
        if (url) {
            if (this.databricksLoginCheckService.isDatabricksUrl(url)) {
                if (await this.databricksLoginCheckService.showDbxAuthModal(url)) {
                    if (this.databricksLoginCheckService.isBaseUrl(url)) {
                        this.databricksLoginCheckService.handleBaseUrl(url);
                    } else {
                        this.databricksLoginCheckService.promptDbxLoginForExternalNavigation(url).subscribe();
                    }
                } else {
                    this.window.open(this.databricksLoginCheckService.getSanitizedTargetDbxUrl(url));
                }
            } else {
                this.window.open(this.databricksLoginCheckService.getLaunchUrl(url));
            }
            this.updateLastView.emit(this.application);
        } else {
            event?.stopPropagation();
            event?.preventDefault();
        }
    }

    favClicked(event?: MouseEvent): void {
        event?.stopPropagation();
        event?.preventDefault();
        if (this.isPreviewMode) {
            return;
        }
        this.toggleFavorite.emit(this.application);
    }
}
